import React from 'react';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Icon from '../../../elements/icons/Icon';

export default class Header extends React.PureComponent {
    render() {
        let {event, form, group} = this.props;

        // TODO: add checkmark icon to groups already completed

        return (
            <div className="EventForm--Header">
                <TopBarEvent event={event} returnURL="..">
                    {form.name}
                </TopBarEvent>
                <div className="content" style={{}}>
                    <h3>{group.title}</h3>
                    <p
                        className="text"
                        style={{
                            fontSize: '120%',
                            margin: '10px 0',
                        }}>
                        {group.description}
                    </p>
                    <div className="background"></div>
                    <table
                        className="layout text-center"
                        style={{
                            marginTop: '3ex',
                            zIndex: 2,
                        }}>
                        <tbody>
                            <tr>
                                {_(form.groups)
                                    .map((g, i) => [
                                        <td
                                            key={'g' + i}
                                            style={{
                                                width: g.id == group.id ? '50px' : '36px',
                                            }}>
                                            <div
                                                className={'groupIcon' + (g.id == group.id ? ' active' : i < this.props.groupIndex ? ' complete' : '')}
                                                style={{
                                                    backgroundColor: g.id == group.id ? event.settings.primary_color : null,
                                                }}>
                                                <Icon className="full-center" src={'/img/forms/' + g.icon} color="white" size={16} />
                                                <div className="complete"></div>
                                            </div>
                                        </td>,
                                        i < form.groups.length - 1 ? (
                                            <td
                                                key={'s' + i}
                                                style={{
                                                    height: '36px',
                                                }}>
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        height: '100%',
                                                        zIndex: 3,
                                                    }}>
                                                    <div
                                                        className="full-center"
                                                        style={{
                                                            width: '100%',
                                                            marginTop: '-2px',
                                                            border: '2px dashed #b8b8b8',
                                                        }}></div>
                                                </div>
                                            </td>
                                        ) : null,
                                    ])
                                    .flatten()
                                    .compact()
                                    .value()}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
